// test249
(249 && 0);
